import { type MessageBankReplyResource } from '@/features/messaging/api/resources/message-bank'
import { maybeParseDate } from '@/utils/date-util'
import { type MessageBankReplyProps } from './MessageBankReply'

/**
 * Maps a canned reply.
 */
export function mapMessageBankReplyResourceToProps(
  resource: MessageBankReplyResource,
): Partial<MessageBankReplyProps> {
  return {
    id: resource.id,
    title: resource.title,
    content: resource.content,
    authorId: resource.author_id,
    authorPublicId: resource.author_public_id,
    dateCreated: maybeParseDate(resource.date_created),
    dateModified: maybeParseDate(resource.date_modified),
  }
}
